import { render, staticRenderFns } from "./PerfomanceBlock.vue?vue&type=template&id=77f0ebd5&scoped=true&"
import script from "./PerfomanceBlock.vue?vue&type=script&lang=js&"
export * from "./PerfomanceBlock.vue?vue&type=script&lang=js&"
import style0 from "./PerfomanceBlock.vue?vue&type=style&index=0&id=77f0ebd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0ebd5",
  null
  
)

export default component.exports